import React from "react";
import { connect } from "react-redux";
import SizeDropdown from "./SizeDropdown";
import { toggleSizeDropdown } from "../../../../Redux/slices/singleProduct";

const mapStateToProps = state => {
    return {
        activeVariation: state.singleProduct.activeVariation.value
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleSizeDropdown: payload => dispatch(toggleSizeDropdown(payload))
    }
}

class PickSize extends React.Component {
    constructor() {
        super();
        this.toggleSizeDropdown = this.toggleSizeDropdown.bind(this);
    }

    toggleSizeDropdown() {
        this.props.toggleSizeDropdown({ visible: true });
    }

    render() {
        var selectSizeText = "Select size";
        if (this.props.activeVariation) {
            selectSizeText = <span>{this.props.activeVariation} <span className="change-size">(change)</span></span>
        }

        return <div className="size-container">
            <SizeDropdown variations={this.props.variations} />

            <div className="pick-size-wrap">
                <div className="size-dropdown" onClick={this.toggleSizeDropdown}>{selectSizeText}</div>
                {/* <div className="size-guide">Size guide</div> */}
            </div>
        </div>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PickSize);